import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import 'preact/devtools';

// Importing Middlewares
import { middlewares } from './middlewares/middlewares';
import rootReducer from '../reducers/Root';

const configureStore = (initialState = {}) => {
  const isProduction = import.meta.env.PROD;
  const middleware = applyMiddleware(...middlewares);

  // TODO: When we have a service to fetch customer data we will use this to rehydrate.
  const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['app', 'userData', 'section'],
  };

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  // If Production
  if (isProduction) {
    return createStore(
      persistedReducer,
      middleware
    );
  }

  // If Not Production
  // Enable DevTools if browser extension is installed
  let enhancer;
  if (window.__REDUX_DEVTOOLS_EXTENSION__) { // eslint-disable-line
    enhancer = compose(
      middleware,
      window.__REDUX_DEVTOOLS_EXTENSION__() // eslint-disable-line
    );
  } else {
    enhancer = compose(middleware);
  }

  return createStore(
    persistedReducer,
    initialState,
    enhancer
  );
};


const generateStore = () => {
  const store = configureStore(window.__INITIAL_STATE__); // eslint-disable-line
  return {
    store,
    persistor: persistStore(store),
  };
};

export { generateStore };
